import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { connect } from "react-redux"
import { setFilters } from "../../filters/actions"
import { GLOBAL_FILTER_IDENTIFIER } from "../../filters/reducer"
import type { FiltersIdentifier } from "../../filters/types"
import { getMibServicePickerSelectedId } from "./selectors"
import { settingsImageUploadResetData } from "../../screens/settings/actions"
import { SingleTerminalPicker } from "./SingleTerminalPicker"
import { TerminalType } from "../../../graphql/types"

type Props = {
    selectedId: Maybe<string>
    setFilters: (identifier: FiltersIdentifier, attributes: any) => void
    resetDesktopImageToUpload: () => void
}

class MibTerminalsPicker extends React.PureComponent<Props> {
    handleSetServicesFilter = (id: string) => {
        this.props.setFilters(GLOBAL_FILTER_IDENTIFIER, {
            selectedMibTerminalId: id,
        })
        this.props.resetDesktopImageToUpload()
    }

    render() {
        return (
            <SingleTerminalPicker
                terminalTypes={[TerminalType.Mib, TerminalType.Aggregator]}
                onChange={this.handleSetServicesFilter}
                selectedTerminalId={this.props.selectedId}
            />
        )
    }
}

const mapStateToProps = state => ({
    selectedId: getMibServicePickerSelectedId(state),
})

const mapDispatchToProps = {
    setFilters: setFilters,
    resetDesktopImageToUpload: settingsImageUploadResetData,
}
export default connect<any, any, any>(mapStateToProps, mapDispatchToProps)(MibTerminalsPicker)
